// extracted by mini-css-extract-plugin
export default {"member_item":"member-item_member_item__jojGJ","name_email":"member-item_name_email__kesUg","name":"member-item_name__8HSEt","email":"member-item_email__mU1MY"};